module.exports = __webpack_public_path__ + "static/chubbHome-2501528cdc56382f07173d5ac5ea0587.png";